import React from 'react';

import Step1SelectType from './steps/step-1-select-type';
import ModalCustomField_Step2Form from "./steps/step-2-form";
import {ModalCustomField_Mode, ModalCustomFieldParams} from "../modal";

enum Step {
    SELECT_FIELD_TYPE   = 'step_1',
    FILED_SETTINGS      = 'step_2'
}

type State = {
    step    : Step
    type    : any
}

type Props = {
    params          : ModalCustomFieldParams
    type            : ModalCustomField_Mode

    onSubmit        : callback
    onClick         : callback
    onClickBack     : callback
    onClickClose    : callback
}

// const debug = "ModalCustomField_Form"
const debug = false

export default class ModalCustomField_Form extends React.Component<Props, State> {

    constructor(props:any) {
        super(props);

        debug && console.log(debug, "constructor()")

        let step = Step.SELECT_FIELD_TYPE;
        let type = null;
        if (props.params) {
            if (props.params.customField) {
                step = Step.FILED_SETTINGS;
                type = props.params.customField.type;
            } else if (props.params.customFieldType) {
                step = Step.FILED_SETTINGS;
                type = props.params.customFieldType;
            }
        }

        this.state = {
            step    : step,
            type    : type
        };
    }

    onCloseClick = () => {
        gd.modal.hide();
    }

    onBackToStep1 = () => {this.setState({ step: Step.SELECT_FIELD_TYPE })}
    onSelectType = (type:string) => {
        this.setState({
            step    : Step.FILED_SETTINGS,
            type    : type
        })
    }
    onSubmit = (result:any) => {this.props.onSubmit(result)}

    render() {
        switch (this.state.step) {
            case Step.SELECT_FIELD_TYPE:
                return <Step1SelectType onSelectType={this.onSelectType}
                                        onCloseClick={this.onCloseClick}/>;

            case Step.FILED_SETTINGS:
                return <ModalCustomField_Step2Form isNew={this.props.type === 'new'}
                                                   type={this.state.type}
                                                   params={this.props.params}
                                                   onBackToStep1={this.onBackToStep1}
                                                   onCloseClick={this.onCloseClick}
                                                   onSubmit={this.onSubmit}/>;
        }

        return false;
    }
}
